import React from "react";
import ScoreInfoTip from "@/components/ScoreInfoTip";

export function ScoreGauge({ value = 0, label = "", size = 140, testid, infoVariant = null }) {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  const stroke = 6;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (pct / 100) * c;
  const color = pct >= 80 ? "#10B981" : pct >= 50 ? "#F59E0B" : "#EF4444";
  return (
    <div
      data-testid={testid}
      className="relative flex flex-col items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="#27272A"
          strokeWidth={stroke}
          fill="transparent"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          fill="transparent"
          strokeDasharray={c}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 800ms ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="text-3xl font-semibold tracking-tight text-zinc-50">
          {pct}
          <span className="text-base text-zinc-500 font-medium">/100</span>
        </div>
        {label && (
          <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1 inline-flex items-center gap-1">
            {label}
            {infoVariant && <ScoreInfoTip variant={infoVariant} label={label} />}
          </div>
        )}
      </div>
    </div>
  );
}

export function ScoreBar({ label, value, testid, infoVariant = null }) {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  const color = pct >= 80 ? "bg-emerald-500" : pct >= 50 ? "bg-amber-500" : "bg-rose-500";
  return (
    <div data-testid={testid} className="space-y-2">
      <div className="flex items-center justify-between text-xs">
        <span className="text-zinc-400 uppercase tracking-wider font-medium inline-flex items-center gap-1.5">
          {label}
          {infoVariant && <ScoreInfoTip variant={infoVariant} label={label} />}
        </span>
        <span className="text-zinc-200 font-semibold tabular-nums">{pct}</span>
      </div>
      <div className="h-1.5 rounded-full bg-zinc-800 overflow-hidden">
        <div
          className={`h-full ${color} transition-all duration-700 ease-out`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
